// extracted by mini-css-extract-plugin
module.exports = {"root":"WordPressArchiveList_root__1_--p","description":"WordPressArchiveList_description__GJTf0","link":"WordPressArchiveList_link__3bd6K"};